module.exports = __webpack_public_path__ + "static/media/minus_icon.90a9baee.svg";